module.exports = __webpack_public_path__ + "img/fondo-login.bff394de.jpg";